import { Button, Tooltip } from "@mui/material";
import React from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import "./../header/Header.css";

export const ComBtn = ({ sx, onClick, text }) => {
  const vMediaQuery = useMediaQuery("(max-width:600px)");
  const isContact = text === "Contact Us";


  return (
    <Tooltip title={isContact ? "View Contact info!":""}>
      <Button
        variant="outlined"
        className={"btn"}
        onClick={onClick}
        sx={{
          background: "linear-gradient(45deg, #357ec7, green)",
          color: "white",
          padding: vMediaQuery ? "2px 2px" : "",
          fontSize: vMediaQuery ? "10px" : "",
          border: "1px solid green",
          textTransform: "capitalize",
          fontWeight: 600,
          "&:hover": {
            textDecoration: "underline",
            fontWeight: 400,
          },
        }}
      >
        {text}
      </Button>
    </Tooltip>
  );
};

